import { AxiosArgs, ThenArgs, ControlLibraryShortRanked, VoteValue } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeBody } from 'src/api/client';

type GetRankedControls = (
  scenarioId: string,
) => Promise<AxiosArgs<ThenArgs<AxiosResponse<ControlLibraryShortRanked[]>>>>;

export const getRankedControls: GetRankedControls = (scenarioId) => {
  const path = `/api/public/api/controllibraries/ranked-controls?scenarioId=${scenarioId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------

type ScoreControlVote = (params: {
  control_id: string;
  score: VoteValue;
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse<ControlLibraryShortRanked[]>>>>;

export const scoreControlVote: ScoreControlVote = (params) => {
  const path = `/api/public/api/controllibraries/score-control`;
  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(params),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------
